import { useState } from 'react';
import { prepareExportToExcelPayload } from '@/creditflowresearch/application/TopCompanies/helpers';
import DownloadRepository from '@/creditflowresearch/infrastructure/repository/DownloadRepository';
import { getContainer } from '@framework/di/getContainer';
import { AlertManager } from '@creditflowresearch/uilib/Alert';
import { useMessageManager } from '@framework/message';
import downloadFile from '@framework/api/downloadFile';
import { useUserTimeZoneContext } from '@/creditflowresearch/application/User/UserTimeZone/UserTimeZoneContext';

export default function useExportButtonWithSpinner(serverShowExport) {
  const container = getContainer();
  const [isExportAvailable, setIsExportAvailable] = useState<boolean>(serverShowExport);
  const [isExportFetching, setIsExportFetching] = useState(false);
  const { getErrorMessage } = useMessageManager();
  const { timeZone } = useUserTimeZoneContext();

  const downloadExcelFile = async (params): Promise<void> => {
    const payload = prepareExportToExcelPayload({ ...params, timeZone });
    setIsExportFetching(true);
    try {
      const downloadRepository = container.get<DownloadRepository>(DownloadRepository);
      const exportUrl = await downloadRepository.getTopCompanyExcelExport(payload);
      downloadFile(exportUrl);
    } catch (e) {
      AlertManager.error(getErrorMessage(e));
    } finally {
      setIsExportFetching(false);
    }
  };

  return {
    isExportFetching,
    isExportAvailable,
    downloadExcelFile,
    setIsExportAvailable,
  };
}
